import { Modal } from "components";
import RequiredNumberInput from "components/ValidatedFields/RequiredNumberInput";
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import { EditSectionTemplate } from "components/MainSectionTemplate/EditSectionTemplate";
import React from "react";

interface Props {
  clientId: number;
  onClose: () => void;
}

interface AddCreditFormState {
  amount: number;
  reason: string;
}

export const AddCreditModal = (props: Props) => {
  const [formState, setFormState] = React.useState<AddCreditFormState>({
    amount: serverReference.constants.credit.defaultPromoAmount,
    reason: "",
  });

  const onChange = (newData: Partial<AddCreditFormState>) => {
    setFormState((prevState) => ({
      ...prevState,
      ...newData,
    }));
  };

  const submit = () => {
    return window.CoreApi.Credit.AddPromoCredits({
      clientId: props.clientId,
      amount: formState.amount,
      reason: formState.reason,
      expiresInMonths: 0
    });
  };

  const onSuccess = () => {
    props.onClose();
  };

  return <Modal
    isOpen
    handleClose={props.onClose}
    title="Add promo credit"
    width="tiny"
  >
    <div className="grow1 scrollbox-auto">
      <EditSectionTemplate
        submit={submit}
        noPanels
        onSuccess={onSuccess}
        sections={[{
          key: "creditDetails",
          type: "regular",
          title: "Add promo credit",
          fields: [{
            key: "amount",
            label: "Amount",
            renderEditNew: () => <RequiredNumberInput
              minValue={serverReference.constants.credit.minPromoAmount}
              maxValue={serverReference.constants.credit.maxPromoAmount}
              value={formState.amount}
              onChange={(amount: number) => onChange({ amount })}
              decimalPoints={0}
              canBeEmpty={false}
              canBeNegative={false}
              validatorKey="amount"
              width={75}
              labelContent="EUR"
            />
          }, {
            key: "reason",
            label: "Reason",
            renderEditNew: () => <RequiredTextInput
              value={formState.reason}
              onChange={(reason: string) => onChange({ reason })}
              maxLength={500}
              validatorKey="reason"
            />
          }]
        }]}
      />
    </div>
  </Modal>
}
